module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__("styled-components");
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// CONCATENATED MODULE: ./src/Switch/Switch.styles.ts

var HEIGHT = 28;

var disabledStyles = function disabledStyles(p) {
  return p.disabled && "\n  background: transparent;\n  pointer-events: none;\n  color: " + function (props) {
    return props.theme.carvana.gray.medium;
  } + ";\n  opacity: 0.7;\n";
};

var SwitchButton = external_styled_components_default.a.div.withConfig({
  displayName: "SwitchButton",
  componentId: "g8jqll-0"
})(["display:inline-flex;flex-flow:row;flex:1 1 auto;position:relative;box-sizing:border-box;background:", ";padding:0;border:1px solid;border-color:", ";color:", ";font-size:12px;border-radius:", "px;height:", "px;outline:none;min-width:", "px;cursor:pointer;transition:background 350ms ease-in-out;-webkit-tap-highlight-color:transparent;", " ", ""], function (props) {
  return props.theme.carvana.gray.background;
}, function (props) {
  return props.theme.carvana.gray.light;
}, function (props) {
  return props.theme.carvana.blue.dark;
}, HEIGHT, HEIGHT + 2, HEIGHT * 2, function (props) {
  return props.isOn && props.showOnBackground ? "background: " + props.theme.carvana.blue.primary + ";" : '';
}, disabledStyles);
var SlidingBackground = external_styled_components_default.a.div.withConfig({
  displayName: "SlidingBackground",
  componentId: "g8jqll-1"
})(["background:", ";height:", "px;width:50%;box-sizing:border-box;min-width:", "px;border-radius:", "px;position:absolute;border-left:1px solid;border-right:1px solid;border-color:", ";transition:transform 350ms cubic-bezier(0.2,0.0,0.2,1);box-sizing:border-box;transform:", ";"], function (props) {
  return props.theme.carvana.white.primary;
}, HEIGHT, HEIGHT, HEIGHT, function (props) {
  return props.theme.carvana.gray.light;
}, function (props) {
  return props.isOn ? 'translateX(100%) translateX(1px)' : 'translateX(-1px)';
});

var isFirstOnBlueBackground = function isFirstOnBlueBackground(p) {
  return !p.isSelected && p.showOnBackground && p.index === 0;
};

var SwitchLabel = external_styled_components_default.a.div.withConfig({
  displayName: "SwitchLabel",
  componentId: "g8jqll-2"
})(["background:transparent;height:", "px;margin:0;flex:1;line-height:", "px;border-radius:", "px;text-align:center;font-size:12px;text-transform:uppercase;font-weight:700;outline:none;-webkit-touch-callout:none;user-select:none;z-index:1;", ":hover{color:", ";text-decoration:none;}", ""], HEIGHT, HEIGHT - 1, HEIGHT, function (props) {
  return !props.isSelected ? "color: " + props.theme.carvana.blue.primary + ";" : '';
}, function (props) {
  return !props.isSelected ? props.theme.carvana.blue.hover : 'inherit';
}, function (props) {
  return isFirstOnBlueBackground(props) ? "\n    color: " + props.theme.carvana.blue.dark + ";\n    :hover {\n      color: inherit;\n    }\n    " : '';
});
// CONCATENATED MODULE: ./src/Switch/Switch.tsx


var shouldIgnoreClick = function shouldIgnoreClick(onlyClickToActivateSide, toIndex, isOn) {
  return onlyClickToActivateSide && toIndex === Number(isOn);
};

var Switch_Switch = function Switch(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [{
    value: 'off',
    display: ''
  }, {
    value: 'on',
    display: ''
  }] : _ref$options,
      _ref$selection = _ref.selection,
      selection = _ref$selection === void 0 ? 'off' : _ref$selection,
      _ref$onUpdate = _ref.onUpdate,
      onUpdate = _ref$onUpdate === void 0 ? function (f) {
    return f;
  } : _ref$onUpdate,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$testHook = _ref.testHook,
      testHook = _ref$testHook === void 0 ? 'Switch' : _ref$testHook,
      _ref$showOnBackground = _ref.showOnBackground,
      showOnBackground = _ref$showOnBackground === void 0 ? false : _ref$showOnBackground,
      _ref$onlyClickToActiv = _ref.onlyClickToActivateSide,
      onlyClickToActivateSide = _ref$onlyClickToActiv === void 0 ? false : _ref$onlyClickToActiv;
  var indexOfSelection = options.findIndex(function (x) {
    return x.value === selection;
  });
  var isOnFromProps = !!Math.max(indexOfSelection, 0);

  var _useState = Object(external_react_["useState"])(isOnFromProps),
      isOn = _useState[0],
      setIsOn = _useState[1];

  Object(external_react_["useEffect"])(function () {
    setIsOn(isOnFromProps);
  }, [isOnFromProps]);

  var toggleSelection = function toggleSelection(toIndex) {
    if (shouldIgnoreClick(onlyClickToActivateSide, toIndex, isOn)) return;
    setIsOn(!isOn);
    onUpdate(options[Number(!isOn)]);
  };

  return /*#__PURE__*/external_react_default.a.createElement(SwitchButton, {
    role: "switch",
    "aria-checked": isOn,
    "aria-readonly": disabled,
    disabled: disabled,
    className: className,
    "data-cv-test": testHook,
    isOn: isOn,
    showOnBackground: showOnBackground
  }, /*#__PURE__*/external_react_default.a.createElement(SlidingBackground, {
    isOn: isOn
  }), options.map(function (_ref2, i) {
    var value = _ref2.value,
        display = _ref2.display;
    return /*#__PURE__*/external_react_default.a.createElement(SwitchLabel, {
      key: value,
      isSelected: Number(isOn) === i,
      showOnBackground: showOnBackground,
      onClick: function onClick() {
        return toggleSelection(i);
      },
      index: i
    }, display);
  }));
};

/* harmony default export */ var src_Switch_Switch = (Switch_Switch);
// CONCATENATED MODULE: ./src/Switch/index.ts


/* harmony default export */ var src_Switch = (src_Switch_Switch);
// CONCATENATED MODULE: ./src/index.ts
/* concated harmony reexport default */__webpack_require__.d(__webpack_exports__, "default", function() { return src_Switch; });


/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "styled-components":
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map